import { render, staticRenderFns } from "./optionBank.vue?vue&type=template&id=33ae2f18&scoped=true"
import script from "./optionBank.vue?vue&type=script&lang=js"
export * from "./optionBank.vue?vue&type=script&lang=js"
import style0 from "./optionBank.vue?vue&type=style&index=0&id=33ae2f18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ae2f18",
  null
  
)

export default component.exports